import crossIcon from "src/assets/cross.svg";
import { useToast } from "src/hooks/useToast";
import { useState } from "react";
import { Button, Input } from "src/components";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import { useEventStatus } from "src/hooks/useEventStatus";
import { useDispatch } from "react-redux";
import { saoExemptUpdate } from "src/services/invoice-api";
import { getOrderDetailsByOrderCode2 } from "src/services/order-api";
import { ordActions } from "src/context/order-slice";

const SaoToggleRemarks = ({ onCloseModal, saoApplicable }: { onCloseModal: () => void, saoApplicable: boolean }) => {
    const { toast } = useToast();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { orderDetailsFiltered } = useSelector((state: RootState) => state.ord);
    const orderDetails = orderDetailsFiltered?.[0];
    const [remarks, setRemarks] = useState<string>("");
    const { withEventCheck } = useEventStatus();
    const dispatch = useDispatch();


    const handleSaoApplicable = async () => {
        if (!remarks) {
            toast({ description: "Please enter remarks", variant: "destructive" });
            return;
        }
        setIsLoading(true);
        try {
            const payload = {
                "data": {
                    "order_code": orderDetails?.order_code,
                    "remarks": remarks,
                    "order_id": orderDetails?.order_id_int,
                    "sao_block_exempt": saoApplicable || false,
                },
                "primary_key": orderDetails?.order_id_int,
                "event_type": "ORDER_SAO_UPDATE"
            }
            const response = await saoExemptUpdate(payload, orderDetails?.company_code);
            const response2 = await withEventCheck(
                () => {
                    return getOrderDetailsByOrderCode2(orderDetails?.order_code, orderDetails?.company_code);
                },
                response?.data?.data?.eventStreamCreated?.streamId,
                orderDetails?.company_code  //M10-12758
            );
            dispatch(ordActions.setOrderDetailsFiltered([response2?.data?.data]));
            toast({ description: "SAO Exempt updated successfully", variant: "default" });
        } catch (error) {
            console.log(error);
            toast({ description: "Failed to update SAO Exempt", variant: "destructive" });
        } finally {
            setIsLoading(false);
            onCloseModal();
        }
    };

    return (
        <div className="flex flex-col gap-y-2 mb-4 w-[340px] max-h-[318px] mx-auto px-6 bg-white p-4 rounded-xl">
            <div className="flex justify-between items-center">
                <p className="text-lg font-semibold text-gray-800">SAO Exemption</p>
                <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
                    <img src={crossIcon} alt="Close" className="w-5 h-5 invert cursor-pointer" />
                </Button>
            </div>

            <p className="text-sm text-gray-600 mt-4">
                Are you sure you want to {saoApplicable ? "add" : "remove"} SAO Exemption?
            </p>


            <Input
                placeholder="Enter remarks"
                value={remarks}
                onChange={(e: any) => setRemarks(e.target.value)}
            />
            <div className="flex justify-end gap-2 mt-4">
                <Button className="bg-gray-300 text-gray-700 hover:bg-[#BFC5CC] px-4 py-2 rounded-lg" onClick={onCloseModal}>
                    Cancel
                </Button>
                <Button
                    loaderSize="small"
                    isLoading={isLoading}
                    className="text-white bg-[#8051FF] hover:bg-[#6E3DFF] px-4 py-2 rounded-lg"
                    onClick={handleSaoApplicable}
                >
                    Proceed
                </Button>
            </div>
        </div>
    );
};

export default SaoToggleRemarks;
